import React from 'react';
import { motion } from 'framer-motion';
import { PartyPopperIcon } from 'lucide-react';
import type { Location } from '../../lib/types';
interface Props {
  location?: Location;
  onVoteAgain?: () => void;
}
export function ThankYou({
  location
}: Props) {
  return <motion.section initial={{
    opacity: 0,
    scale: 0.94,
    y: 12
  }} animate={{
    opacity: 1,
    scale: 1,
    y: 0
  }} transition={{
    type: 'spring',
    stiffness: 180,
    damping: 18
  }} className="mx-auto max-w-lg rounded-[2rem] border border-white/80 bg-[#fbfaf6] p-10 text-center shadow-2xl" aria-live="polite" data-id="element-311" data-mp="3emqcya0saopa">
      <motion.div initial={{
      rotate: -12,
      scale: 0.6
    }} animate={{
      rotate: 0,
      scale: 1
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 12,
      delay: 0.1
    }} className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-[#315146] text-[#f3d78f] shadow-lg" data-id="element-312" data-mp="2vqqfijp1esyb">
        <PartyPopperIcon className="h-10 w-10" data-id="element-313" data-mp="1z7j52mvpleln" />
      </motion.div>

      <h2 className="font-display text-3xl font-700 text-slate-800" data-id="element-314" data-mp="21qgm0aymrt6p">
        🎉 Thank You!
      </h2>
      <p className="mt-2 text-lg text-slate-600" data-id="element-315" data-mp="26oi2co4o9eeh">
        Your vote has been recorded successfully.
      </p>

      {location && <div className="mt-6 inline-flex items-center gap-3 rounded-2xl bg-[#e9f0e5] px-5 py-3" data-id="element-316" data-mp="2bh1jtw6hctok">
          <span className="text-2xl" data-id="element-317" data-mp="2gdi7kp9rp614">{location.emoji}</span>
          <span className="text-left" data-id="element-318" data-mp="1irb3dghdlfpa">
            <span className="block text-sm text-slate-500" data-id="element-319" data-mp="1ism417fiy7c6">You voted for</span>
            <span className="block font-display font-600 text-slate-800" data-id="element-320" data-mp="1nr75fa6iix27">
              {location.city}, {location.province}
            </span>
          </span>
        </div>}

      <p className="mt-8 text-sm text-slate-400" data-id="element-321" data-mp="1xov1q4jrocmh">
        Safe travels — see you at the retreat! ✈️
      </p>
    </motion.section>;
}